import React from 'react';

const Footer = ({ column = false}) => {
	const currentYear = new Date().getFullYear()
	return (
		<footer className="footer">
              <div className={`container inner-footer ${column ? 'footer-column-home' : ''}`}>
                    <img src='/img/logo-gray-efisco.png' alt="efisco"/>
                    <a className="advice" href="https://sw.com.mx/aviso-privacidad/" rel="noopener noreferrer" target="_blank">Aviso de privacidad © Lunasoft S.A. de C.V. (2001-{currentYear})</a>
              </div>
        </footer>
	)
}

export default Footer; 